import { Directive, Input, TemplateRef } from '@angular/core';

export interface DataTableCellContext<T = any> {
  row: T;
  value: any;
}

@Directive({
  selector: '[appDataTableCell]',
  standalone: true,
})
export class DataTableCellDirective<T = any> {
  @Input('appDataTableCell') columnKey = '';

  constructor(public template: TemplateRef<DataTableCellContext<T>>) {}
}
